import { useLayoutEffect } from 'react';

/**
 * Registers an element's id with a compound component's root for as long as the element is mounted,
 * so the root can point `aria-labelledby` / `aria-describedby` at whichever parts actually render.
 */
export function useRegisteredId(id: string, register: (id: string | undefined) => void) {
  useLayoutEffect(() => {
    register(id);
    return () => register(undefined);
  }, [id, register]);
}
